import { Flex } from '@components';
import { styled } from '@mui/material';
import { InvestmentContainer } from '../Investment.styles';

export const Container = styled(InvestmentContainer)(() => ({
  zIndex: 1000,
}));

export const ContentContainer = styled(Flex)(({ theme }) => ({
  flex: 1,
  flexDirection: 'column',
  padding: theme.spacing(5, 17),
  paddingTop: theme.spacing(0),
  paddingRight: '33%',
  [theme.breakpoints.between('md', 'lg')]: {
    paddingRight: '10%',
  },
  [theme.breakpoints.down('md')]: {
    padding: theme.spacing(16, 10),
    paddingBottom: theme.spacing(19),
  },
}));
